import { render, staticRenderFns } from "./Passives.vue?vue&type=template&id=6368ce49&"
import script from "./Passives.vue?vue&type=script&lang=js&"
export * from "./Passives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports